import React from 'react'
import styles from './SingleItemBox.module.css'
import { useNavigate } from 'react-router-dom'

const SingleItemBox = (props) => {


  const navigate = useNavigate();

  const clickHandler = () => {
    if (props.text === 'Ayurvedic Encyclopedia') {
      navigate('/ayurvedic-encyclopedia');
    }
    if (props.text === 'Homeopathy Encyclopedia') {
      navigate('/homeopathy-encyclopedia');
    }
    if (props.text === 'Symptoms Checker') {
      navigate('/symptoms-checker');
    }
    if (props.text === 'Practitioners Directory') {
      navigate('/practitioners-directory');
    }
    if (props.text === 'Blog') {
      navigate('/blog');
    }
    if (props.text === 'Remedies Guides') {
      navigate('/remedies-guides');
    }
    if (props.text === 'Meditation Guides') {
      navigate('/meditation-guides');
    }

  }

  return (
    <>
      <li className={styles.list} onClick={clickHandler}>
        <img src={props.image} alt='AC' />
        <p>{props.text}</p>
      </li>

    </>
  )
}

export default SingleItemBox